export type PortalRole = 'member' | 'chair' | 'leader' | 'quartermaster' | 'admin'

export function membershipTierName(slug:string|null|undefined){
  if(slug==='unsure')return 'Help choosing'
  return tiers.find(t=>t.slug===slug)?.name||slug||'No membership path recorded'
}

export const tiers = [
  {
    slug: 'vanguard',
    name: 'Guardians',
    price: '$0',
    youth: '$0 youth (under 18)',
    lead: 'Time & labor',
    summary: 'For members able to give the greatest share of time and hands-on help.',
    commitments: ['All required guild activities', 'Setup and teardown', 'Largest proportional share of faire duties'],
  },
  {
    slug: 'steward',
    name: 'Realmkeepers',
    price: '$25',
    youth: '$15 youth (under 18)',
    lead: 'Balanced contribution',
    summary: 'A practical balance of annual dues, attendance, and guild service.',
    commitments: ['May miss one item in each attendance category', 'Setup and teardown', 'Standard share of faire duties'],
    featured: true,
  },
  {
    slug: 'patron',
    name: 'Flamekeepers',
    price: '$100',
    youth: '$75 youth (under 18)',
    lead: 'Financial support & flexibility',
    summary: 'For members with less available time who can provide more financial support.',
    commitments: ['Current minimum meetings and crafts', 'Setup or teardown', 'Lightest duty share', 'Two annual fee credits'],
  },
  {
    slug: 'out-of-towners',
    name: 'Wayfarers',
    price: '$50',
    youth: '$50 youth (under 18)',
    lead: 'Approval only · Distance accommodation',
    summary: 'For members who live outside the local area and stay connected through meetings and faire service.',
    commitments: ['Required meetings; Discord video attendance counts', 'Exempt from non-faire events', 'Realmkeepers setup, teardown, and guild-duty schedule', 'Bring designated guild crafts to each faire'],
    approvalOnly: true,
  },
  {
    slug: 'entertainers',
    name: 'Revelers',
    price: '$50',
    youth: '$50 youth (under 18)',
    lead: 'Approval only · Faire entertainment',
    summary: 'For approved performers whose substantial faire entertainment replaces regular guild duty.',
    commitments: ['Same meetings, crafts, events, setup, and teardown as Realmkeepers', 'Realmkeepers external-event participation requirement', 'Significant scheduled patron entertainment', 'Exempt from regular guild-duty shifts'],
    approvalOnly: true,
  },
]

export const publicEvents = [
  {
    id: 'public-gathering',
    title: 'Open Guild Gathering',
    date: 'October 24, 2026',
    time: '2:00–5:00 PM',
    location: 'Location to be announced',
    kind: 'Open to the public',
    description: 'Meet members, learn how the guild participates in local faires, and ask about joining.',
  },
  {
    id: 'craft-day',
    title: 'Community Craft Day',
    date: 'November 14, 2026',
    time: '10:00 AM–2:00 PM',
    location: 'Location to be announced',
    kind: 'Open to the public',
    description: 'A casual workday for garb, camp pieces, signage, and shared guild projects.',
  },
]

export const privateEvents = [
  ...publicEvents,
  {
    id: 'planning-meeting',
    title: 'Guild Planning Meeting',
    date: 'October 11, 2026',
    time: '6:30–8:00 PM',
    location: 'Members see location after sign-in',
    kind: 'Members only',
    description: 'Annual calendar, committee assignments, and Pirate Fest preparation.',
  },
]

export const participation = [
  { date: 'Sep 12, 2026', activity: 'Guild craft day', category: 'Craft day', status: 'Verified', credit: '3 hours' },
  { date: 'Aug 29, 2026', activity: 'Recruiting table', category: 'Community event', status: 'Verified', credit: '1 shift' },
  { date: 'Aug 16, 2026', activity: 'Monthly meeting', category: 'Meeting', status: 'Verified', credit: 'Attended' },
  { date: 'Sep 26, 2026', activity: 'Yard inventory support', category: 'Committee service', status: 'Pending', credit: '2 hours' },
]

export const committeeCards = [
  { name: 'Scheduling', role: 'Chair', members: 4, next: 'Oct 6 · 7:00 PM', detail: 'Build faire-duty schedules, publish shifts, and record completed assignments.' },
  { name: 'Membership', role: 'Member', members: 3, next: 'Oct 13 · 6:30 PM', detail: 'Recruit, interview, onboard, retain, and track participation.' },
]

export const directory = [
  { initials: 'MP', name: 'Morgan Pendrake', tier: 'Realmkeepers', committees: 'Events', bio: 'Camp host, craft-day regular, and keeper of the kettle.' },
  { initials: 'RW', name: 'Rowan Wren', tier: 'Guardians', committees: 'Setup & Teardown', bio: 'Builder, hauler, and problem-solver when the ground is uneven.' },
  { initials: 'AS', name: 'Avery Stone', tier: 'Flamekeepers', committees: 'Membership', bio: 'Welcomes new faces and helps turn interest into belonging.' },
]
